"use client";

import * as Sentry from "@sentry/nextjs";
import {
    MutationCache,
    QueryCache,
    QueryClient,
    QueryClientProvider,
} from "@tanstack/react-query";
import { useState } from "react";

export default function QueryProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                queryCache: new QueryCache({
                    onError: (error, query) => {
                        Sentry.captureException(error, {
                            tags: { source: "react-query" },
                            extra: { queryKey: query.queryKey },
                        });
                    },
                }),
                mutationCache: new MutationCache({
                    onError: (error) => {
                        Sentry.captureException(error, {
                            tags: { source: "react-query-mutation" },
                        });
                    },
                }),
                defaultOptions: {
                    queries: {
                        staleTime: 5 * 60 * 1000, // 5 minutes
                        retry: (failureCount, error: any) => {
                            // Don't retry on 4xx errors (client errors)
                            if (error?.status >= 400 && error?.status < 500) {
                                return false;
                            }
                            return failureCount < 3;
                        },
                    },
                    mutations: {
                        retry: false,
                    },
                },
            }),
    );

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}
